// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { helpWidgetStyles } from "@awc/App/Widgets/HelpWidget/HelpWidget";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, getSystemColor } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

helpWidgetStyles.wrapper = {
    css: css`
        padding: 16px;
    `,
};

helpWidgetStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        background: ${color("secondary")};
        min-height: 40px;
        padding: 8px;
    `,
};
helpWidgetStyles.title = {
    color: "common.ui1",
    variant: "h3",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};
helpWidgetStyles.infoWrapper = {
    css: css`
        padding: 12px;
        border: 1px solid ${color("common.border")};
        border-top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    `,
};
helpWidgetStyles.phone = {
    color: "common.border",
};
helpWidgetStyles.link = {
    color: "secondary",
    css: css`
        margin-top: 18px;
        display: block;
        &:hover {
            ${TypographyStyle} {
                color: ${color("common.ui10")};
            }
        }
        &:focus {
            ${TypographyStyle} {
                color: ${color("common.ui11")};
            }
        }
        &:first-of-type {
            margin-top: 0;
        }
    `,
    typographyProps: {
        size: fontConfig.fontSize.link,
        css: css`
            color: ${color("secondary")};
        `,
    },
};
helpWidgetStyles.message = {
    color: "common.border",
    size: fontConfig.fontSize.xSmall,
    lineHeight: fontConfig.lineHeight.xSmall,
};
helpWidgetStyles.contactLink = {
    color: "common.border",
    typographyProps: {
        weight: fontConfig.weight.regular,
    },
    hoverStyle: {
        color: getSystemColor("common.ui17"),
    },
};
